export enum EColorPickerTypes {
    solid = 'solid',
    gradient = 'gradient',
}

export enum EColorPickerGradientTypes {
    linearGradient = 'linear-gradient',
}
